import { render } from "./FPForm.vue?vue&type=template&id=3fd1261d"
import script from "./FPForm.vue?vue&type=script&lang=js"
export * from "./FPForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__